<template>
  <div class="content">
    <h1 style="font-size: 22pt; line-height: 240%; margin: 17pt 0pt 16.5pt; orphans: 0; page-break-after: avoid; page-break-inside: avoid; text-align: center; widows: 0;">
      <span style="font-family: Calibri; font-size: 22pt; font-weight: bold;">“</span><span style="font-family: 宋体; font-size: 22pt; font-weight: bold;">临猗在线</span><span style="font-family: Calibri; font-size: 22pt; font-weight: bold;">APP”</span
      ><span style="font-family: 宋体; font-size: 22pt; font-weight: bold;">用户协议</span>
    </h1>
    <p class="pt">
      <span class="ch">欢迎您使用“临猗在线</span>
      <span class="en">APP</span>
      <span class="ch">”平台（以下简称“本平台”）！</span>
    </p>
    <p class="pt">
      <span class="ch">为了更好地为您提供服务，请您仔细阅读《“临猗在线</span>
      <span class="en">APP</span>
      <span class="ch"
        >”用户协议》（以下简称“本协议”）。在您开始使用本平台服务（以下简称“本服务”）之前，请您务必认真阅读并充分理解本协议，特别是涉及免除或者限制责任的条款、权利许可和信息使用的条款、同意开通和使用特殊单项服务的条款、法律适用和争议解决条款等。其中，免除或者限制责任条款等重要内容将以加粗形式提示您注意，您应重点阅读。如您未满</span
      >
      <span class="en">18</span>
      <span class="ch">周岁，请在法定监护人陪同下仔细阅读并充分理解本协议，并征得法定监护人的同意后使用本服务。</span>
    </p>
    <p class="pt">
      <span class="chb">如您不同意本协议，这将导致我们无法为您提供服务。如你选择同意或使用本服务，则视为您已充分理解本协议并承诺作为本协议的一方当事人接受协议、隐私政策以及与本平台相关的规则、规范、声明、公告、通知等内容的约束。</span>
    </p>
    <h4 style="font-weight: bold;">
      <span style="font-family: Calibri;">1</span>
      <span style="font-family: 宋体;">、适用范围</span>
    </h4>
    <p class="pt">
      <span class="en">1.1</span>
      <span class="ch"> 本协议是您与本平台之间就您注册、登录、使用本平台服务，或者获得本平台提供的任何服务所订立的协议。就本协议项下涉及的某些服务，可能会由本平台的关联公司向您提供，您知晓并同意接受上述服务内容，即视为接受双方之间的相关权利义务关系亦受本协议约束。</span>
    </p>
    <p class="pt">
      <span class="en">1.2</span>
      <span class="ch"> “您”是指提交有效申请并注册后，在本平台注册、登录、上传、发布等以各种形式传播内容（包括文字、图片等）的自然人、法人或其他组织。在本协议中称为“网民”或称“您”。</span>
    </p>
    <p class="pt">
      <span class="en">1.3</span>
      <span class="ch"> 您注册本平台账号后可以通过本平台上传发布内容，向用户传播信息、与用户交流互动等。本平台是提供网络信息存储空间的网络服务提供者。</span>
    </p>
    <p class="pt">
      <span class="en">1.4</span>
      <span class="ch"> 本协议内容同时包括本平台已经发布及后续可能不断发布的关于本平台服务的相关协议、规则等内容。前述内容一经正式发布，并以适当的方式送达用户（网站公布、系统通知等），即为本协议不可分割的组成部分，您应同样遵守。</span>
    </p>
    <h4 style="font-weight: bold;">
      <span style="font-family: Calibri;">2</span>
      <span style="font-family: 宋体;">、关于“账号”</span>
    </h4>
    <p class="pt">
      <span class="en">2.1</span>
      <span class="ch"> 本服务为您提供了注册通道，您有权选择合法的字符组合作为自己的账号，并自行设置符合安全要求的密码。您设置的账号、密码是您用以登录并以注册用户身份使用本服务的凭证。</span>
    </p>
    <h4 style="font-weight: bold;">
      <span style="font-family: Calibri;">3</span>
      <span style="font-family: 宋体;">、用户个人信息保护</span>
    </h4>
    <p class="pt">
      <span class="ch"
        >公司与您一同致力于您个人信息的保护，保护用户个人信息是本平台的基本原则之一。在使用本平台及相关服务的过程中，您可能需要提供您的个人信息（包括但不限于姓名、电话号码、位置信息等），以便公司向您提供更好的服务和相应的技术支持。公司将运用加密技术、匿名化处理等其他与头本平台及相关服务相匹配的技术措施及其他安全措施保护您的个人信息，更多关于用户个人信息保护的内容，请参见
        <a href="/spa/system/privacy">《隐私政策》</a>。
      </span>
    </p>
    <h4 style="font-weight: bold;">
      <span style="font-family: Calibri;">4</span>
      <span style="font-family: 宋体;">、权利和义务</span>
    </h4>
    <p class="pt">
      <span class="en">4.1</span>
      <span class="ch"> 行文要求</span>
    </p>
    <p class="pt">
      <span class="ch">您应当对您使用本服务的行为负责，除非法律允许或者经本平台事先书面许可，您使用本服务不得具有下列行为：</span>
    </p>
    <p class="pt">
      <span class="en">4.1.1</span>
      <span class="ch"> 使用未经本平台授权或许可的任何插件、外挂、系统或第三方工具对本服务的正常运行进行干扰、破坏、修改或施加其他影响。</span>
    </p>
    <p class="pt">
      <span class="en">4.1.2</span>
      <span class="ch"> 利用或针对本服务进行任何危害计算机网络安全的行为，包括但不限于：</span>
    </p>
    <p class="pt">
      <span class="ch">（1）非法侵入他人网络、干扰他人网络正常功能、窃取网络数据等危害网络安全的活动；</span>
    </p>
    <p class="pt">
      <span class="ch">（2）提供专门用于从事侵入网络、干扰网络正常功能及防护措施、窃取网络数据等危害网络安全活动的程序、工具；</span>
    </p>
    <p class="pt">
      <span class="ch">（3）明知他人从事危害网络安全的活动的，为其提供技术支持、广告推广、支付结算等帮助；</span>
    </p>
    <p class="pt">
      <span class="ch">（4）使用未经许可的数据或进入未经许可的服务器/账号；</span>
    </p>
    <p class="pt">
      <span class="ch">（5）未经允许进入公众计算机网络或者他人计算机系统并删除、修改、增加存储信息；</span>
    </p>
    <p class="pt">
      <span class="ch">（6）未经许可，企图探查、扫描、测试本服务系统或网络的弱点或其它实施破坏网络安全的行为；</span>
    </p>
    <p class="pt">
      <span class="ch">（7）企图干涉、破坏本服务系统或网站的正常运行，故意传播恶意程序或病毒以及其他破坏干扰正常网络信息服务的行为；</span>
    </p>
    <p class="pt">
      <span class="ch">（8）伪造TCP/IP数据包名称或部分名称。</span>
    </p>
    <p class="pt">
      <span class="en">4.1.3</span>
      <span class="ch"> 对本服务进行反向工程、反向汇编、编译或者以其他方式尝试发现本服务的源代码。</span>
    </p>
    <p class="pt">
      <span class="en">4.1.4</span>
      <span class="ch"> 恶意注册本服务账号，包括但不限于频繁、批量注册账号。</span>
    </p>
    <p class="pt">
      <span class="en">4.1.5</span>
      <span class="ch"> 违反法律法规、本协议、平台的相关规则及侵犯他人合法权益的其他行为。</span>
    </p>
    <p class="pt">
      <span class="ch">在任何情况下，如果平台有理由认为您的任何行为违反或可能违反上述约定的，平台可独立进行判断并处理，且在任何时候有权在进行任何事先通知的情况下终止向本平台用户提供服务，并追究相关责任。</span>
    </p>
    <p class="pt">
      <span class="en">4.2</span>
      <span class="ch"> 信息内容权利及规范</span>
    </p>
    <p class="pt">
      <span class="en">4.2.1</span>
      <span class="chb"> 您的制作、复制、上传、发布、传播、评论等内容应自觉遵守宪法法律、法规、遵守公共秩序，尊重社会公德、社会主义制度、国家利益、公民合法权益、道德风尚和信息真实性等要求。您不得制作、复制、上传、发布、传播法律、行政法规禁止的下列信息内容：</span>
    </p>
    <p class="pt">
      <span class="ch">（1）反对宪法确定的基本原则的；</span>
    </p>
    <p class="pt">
      <span class="ch">（2）危害国家安全，泄露国家秘密的；</span>
    </p>
    <p class="pt">
      <span class="ch">（3）颠覆国家政权，推翻社会主义制度、煽动分裂国家、破坏国家统一的；</span>
    </p>
    <p class="pt">
      <span class="ch">（4）损害国家荣誉和利益的；</span>
    </p>
    <p class="pt">
      <span class="ch">（5）宣扬恐怖主义、极端主义的；</span>
    </p>
    <p class="pt">
      <span class="ch">（6）宣扬民族仇恨、民族歧视，破坏民族团结的；</span>
    </p>
    <p class="pt">
      <span class="ch">（7）煽动地域歧视、地域仇恨的；</span>
    </p>
    <p class="pt">
      <span class="ch">（8）破坏国家宗教政策，宣扬邪教和迷信的；</span>
    </p>
    <p class="pt">
      <span class="ch">（9）编造、散布谣言、虚假信息，扰乱经济秩序和社会秩序、破坏社会稳定的；</span>
    </p>
    <p class="pt">
      <span class="ch">（10）散布、传播暴力、淫秽、色情、赌博、凶杀、恐怖或者教唆犯罪的；</span>
    </p>
    <p class="pt">
      <span class="ch">（11）侵害未成年人合法权益或者损害未成年人身心健康的；</span>
    </p>
    <p class="pt">
      <span class="ch">（12）未获他人允许，偷拍、偷录他人，侵害他人合法权利的；</span>
    </p>
    <p class="pt">
      <span class="ch">（13）包含恐怖、暴力血腥、高危险性、危害表演者自身或他人身心健康内容的；</span>
    </p>
    <p class="pt">
      <span class="ch">（14）危害网络安全、利用网络从事危害国家安全、荣誉和利益的；</span>
    </p>
    <p class="pt">
      <span class="ch">（15）侮辱或者诽谤他人，侵害他人合法权益的；</span>
    </p>
    <p class="pt">
      <span class="ch">（16）对他人进行暴力恐吓、威胁，实施人肉搜索的；</span>
    </p>
    <p class="pt">
      <span class="ch">（17）涉及他人隐私、个人信息或资料的；</span>
    </p>
    <p class="pt">
      <span class="ch">（18）散布污言秽语，损害社会公序良俗的；</span>
    </p>
    <p class="pt">
      <span class="ch">（19）侵犯他人隐私权、名誉权、肖像权、知识产权、商业秘密等合法权益内容的；</span>
    </p>
    <p class="pt">
      <span class="ch">（20）未经平台许可，利用本服务为自己或第三方进行推广、发布广告的（包括但不限于加入第三方链接、广告等行为）；</span>
    </p>
    <p class="pt">
      <span class="ch">（21）过度营销信息，骚扰信息和/或垃圾信息、低俗类信息、垃圾广告的；</span>
    </p>
    <p class="pt">
      <span class="ch">（22）使用本平台常用语言文字以外的其他语言文字制作、复制、上传、发布、传播的内容、留言、评论的；</span>
    </p>
    <p class="pt">
      <span class="ch">（23）与所制作、复制、上传、发布、传播的内容、留言、评论的信息毫无关系的；</span>
    </p>
    <p class="pt">
      <span class="ch">（24）所发布、传播的内容毫无意义的，或刻意使用字符组合以逃避技术审核的；</span>
    </p>
    <p class="pt">
      <span class="ch">（25）其他违反法律法规、政策及公序良俗、干扰头条号平台正常运营或侵犯其他用户或第三方合法权益内容的其他信息。</span>
    </p>
    <p class="pt">
      <span class="en">4.3</span>
      <span class="ch"> 为确保平台和用户的利益，您请在使用本服务时，不要进行如下行为（该行为是指使用本平台的账号所进行的任何行为，包括但不限于注册登录、帐号运营、管理及推广以及其他行为）：</span>
    </p>
    <p class="pt">
      <span class="en">4.3.1</span>
      <span class="ch"> 提交、发布虚假信息，或冒充、利用他人名义进行相关活动；</span>
    </p>
    <p class="pt">
      <span class="en">4.3.2</span>
      <span class="ch"> 强制、诱导其他用户关注、点击链接页面或分享信息；</span>
    </p>
    <p class="pt">
      <span class="en">4.3.3</span>
      <span class="ch"> 虚构事实、隐瞒真相以误导、欺骗他人；</span>
    </p>
    <p class="pt">
      <span class="en">4.3.4</span>
      <span class="ch"> 利用平台及帐户从事违法犯罪活动；</span>
    </p>
    <p class="pt">
      <span class="en">4.3.5</span>
      <span class="ch"> 制作、发布与以上行为相关的方法、工具，或对此类方法、工具进行运营或传播；</span>
    </p>
    <p class="pt">
      <span class="en">4.3.6</span>
      <span class="ch"> 其他违反法律法规规定、侵犯其他用户合法权益、干扰产品正常运营或未经公司明示授权的行为。</span>
    </p>
    <p class="pt">
      <span class="en">4.4</span>
      <span class="ch"> 平台设立公众投诉、举报平台，用户可按照平台公示的投诉举报制度向平台投诉、举报各类违法违规行为、违法传播活动、违法有害信息等内容，平台将及时受理和处理用户投诉举报，以共同营造风清气正的网络空间。</span>
    </p>
    <h4 style="font-weight: bold;">
      <span style="font-family: Calibri;">5</span>
      <span style="font-family: 宋体;">、平台数据使用规范</span>
    </h4>
    <p class="pt">
      <span class="en">5.1</span>
      <span class="ch"> 未经平台书面许可，您不得自行或授权、允许、协助任何第三人对本协议平台服务中信息内容进行如下行为：</span>
    </p>
    <p class="pt">
      <span class="ch">（1）复制、读取、采用平台服务的信息内容，用于包括但不限于宣传、增加阅读量、浏览量等商业用途；</span>
    </p>
    <p class="pt">
      <span class="ch">（2）采用包括但不限于特殊标识、特殊代码等任何形式的识别方法，自行或协助第三人对本服务的信息或内容产生流量、阅读量引导、转移、劫持等不利影响；</span>
    </p>
    <p class="pt">
      <span class="ch">（3）其他非法获取本服务的信息内容的行为。</span>
    </p>
    <p class="pt">
      <span class="en">5.2</span>
      <span class="ch"> 经平台书面许可后，您对平台服务的信息和内容的分享、转发等行为，还应符合以下规范：</span>
    </p>
    <p class="pt">
      <span class="ch">（1）对抓取、统计、获得的相关搜索热词、分类、排名、搜索量、点击率、阅读量等相关数据，未经平台事先书面同意，不得将上述数据以任何方式公示、提供、泄露给任何第三人；</span>
    </p>
    <p class="pt">
      <span class="ch">（2）不得对本服务的源网页进行任何形式的任何改动，包括但不限于本服务的主页、各功能接口、广告系统链接等入口，也不得对奔入服务的源页面的展示进行任何形式的遮挡、插入、弹窗等妨碍；</span>
    </p>
    <p class="pt">
      <span class="ch">（3）应当采取安全、有效、严密的措施，防止本服务的信息内容被第三方通过包括但不限于“蜘蛛”（spider）程序等任何形式进行非法获取；</span>
    </p>
    <p class="pt">
      <span class="ch">（4）不得把相关数据内容用于平台书面许可范围之外的目的，进行任何形式的销售和商业使用，或向第三方泄露、提供或允许第三方为任何方式的使用。</span>
    </p>
    <p class="pt">
      <span class="ch">（5）您向任何第三人分享、转发、复制本相关服务信息内容的行为，还应遵守公司为此制定的其他规范和标准。</span>
    </p>
    <h4 style="font-weight: bold;">
      <span style="font-family: Calibri;">6</span>
      <span style="font-family: 宋体;">、违约处理</span>
    </h4>
    <p class="pt">
      <span class="enb">6.1</span>
      <span class="chb">
        针对您违反本协议、隐私政策以及与平台相关的规则、规范、声明、公告、通知等内容的行为，平台有权独立判断并视情况采取预先警示、拒绝发布、要求整改、立即停止传输信息、删除内容/留言/跟帖、暂停更新、冻结账户权益、限制账号部分或者全部功能直至永久关闭账号、要求承担违约或侵权责任等措施。平台有权公告处理结果，且有权根据实际情况决定是否恢复使用。对涉嫌违反法律法规、涉嫌违法犯罪的行为将保存有关记录，并依法向有关主管部门报告、配合有关主管部门调查。</span
      >
    </p>
    <p class="pt">
      <span class="enb">6.2</span>
      <span class="chb">
        因您违反本协议或其他服务条款规定，引起第三方投诉或诉讼索赔的，您应当自行承担全部法律责任。因您的违法或违约行为导致平台及其关联公司损失、或向任何第三方赔偿或遭受国家机关处罚的，平台有权撤回、追缴金额，您应承担违约/侵权责任并应足额赔偿平台及其关联公司因此遭受的全部损失。</span
      >
    </p>
    <p class="pt">
      <span class="enb">6.3</span>
      <span class="chb">
        平台尊重并保护法人、公民的知识产权、名誉权、姓名权、隐私权等合法权益。您保证，在使用本服务时上传的文字、图片、视频、音频、链接等不侵犯任何第三方的知识产权、名誉权、姓名权、隐私权等权利及合法权益。否则，平台有权在收到权利方或者相关方通知的情况下移除该涉嫌侵权内容。针对第三方提出的全部权利主张，您应自行承担全部法律责任；如因您的侵权行为导致平台及其关联公司遭受损失的（包括经济、商誉等损失），您还应足额赔偿平台及其关联公司遭受的全部损失。</span
      >
    </p>
    <h4 style="font-weight: bold;">
      <span style="font-family: Calibri;">7</span>
      <span style="font-family: 宋体;">、服务的变更、中断和终止</span>
    </h4>
    <p class="pt">
      <span class="en">7.1</span>
      <span class="ch">
        您理解并同意，平台提供的服务是按照现有技术和条件所能达到的现状提供的。平台会尽最大努力向您提供服务，确保服务的连贯性和安全性。您理解，公司不能随时预见和防范技术以及其他风险，包括但不限于不可抗力、网络原因、第三方服务瑕疵、第三方网站等原因可能导致的服务中断、不能正常使用本服务以及其他的损失和风险。</span
      >
    </p>
    <p class="pt">
      <span class="en">7.2</span>
      <span class="ch"> 您理解并同意，平台为了服务整体运营、平台运营安全的需要，有权视具体情况决定服务/功能设置、范围，修改、中断、中止或终止平台服务。</span>
    </p>
    <h4 style="font-weight: bold;">
      <span style="font-family: Calibri;">8</span>
      <span style="font-family: 宋体;">、知识产权</span>
    </h4>
    <p class="pt">
      <span class="en">8.1</span>
      <span class="ch">
        平台在本服务中提供的内容（包括但不限于软件、技术、程序、网页、文字、图片、图像、音频、视频、图表、版面设计、电子文档等）的知识产权属于平台所有。平台提供本服务时所依托的软件的著作权、专利权及其他知识产权均归平台所有。未经平台许可，任何人不得擅自使用（包括但不限于通过任何机器人、蜘蛛等程序或设备监视、复制、传播、展示、镜像本服务中的内容）。
      </span>
    </p>
    <p class="pt">
      <span class="enb">8.2</span>
      <span class="chb">
        您理解并同意，在使用本服务时发布上传的文字、图片、视频、音频等均由您原创或已获合法授权。您通过个人账号在平台上传、发布的任何内容的知识产权归属您或原始著作权人所有，且不得侵犯任何第三方的合法权利（包括但不限于知识产权）。
      </span>
    </p>
    <p class="pt">
      <span class="en">8.3</span>
      <span class="ch">
        平台为自身的开发、运营提供技术支持，并对服务的开发和运营等过程中产生的所有数据和信息等享有全部权利。
      </span>
    </p>
    <h4 style="font-weight: bold;">
      <span style="font-family: Calibri;">9</span>
      <span style="font-family: 宋体;">、免责说明</span>
    </h4>
    <p class="pt">
      <span class="enb">9.1</span>
      <span class="chb">
        您理解并同意，本服务可能会受多种因素的影响或干扰，平台不保证(包括但不限于)：
      </span>
    </p>
    <p class="pt">
      <span class="enb">9.1.1</span>
      <span class="chb">
        平台服务完全适合用户的使用所有要求；
      </span>
    </p>
    <p class="pt">
      <span class="enb">9.1.2</span>
      <span class="chb">
        平台不受干扰，及时、安全、可靠或不出现错误；用户经由平台取得的任何软件、服务或其他材料符合用户的期望；
      </span>
    </p>
    <p class="pt">
      <span class="enb">9.1.3</span>
      <span class="chb">
        软件中任何错误都将能得到更正。
      </span>
    </p>
    <p class="pt">
      <span class="enb">9.2</span>
      <span class="chb">
        如果有对于涉嫌借款或其他涉财产的网络信息、账户密码、广告或推广等信息的，请您谨慎对待并自行进行判断，基于前述原因您因此遭受的利润、商业信誉、资料损失或其他有形或无形损失，平台不承担任何直接、间接、附带、特别、衍生性或惩罚性的赔偿责任。
      </span>
    </p>
    <p class="pt">
      <span class="enb">9.3</span>
      <span class="chb">
        您理解并同意，在使用本服务过程中，可能遇到不可抗力等因素（不可抗力是指不能预见、不能克服并不能避免的客观事件），包括但不限于政府行为、自然灾害、网络原因、黑客攻击、战争或任何其它类似事件。出现不可抗力情况时，平台将努力在第一时间及时修复，但因不可抗力给用户造成的损失，平台不承担责任。
      </span>
    </p>
    <p class="pt">
      <span class="enb">9.4</span>
      <span class="chb">
        平台依据本协议约定获得处理违法违规内容的权利，该权利不构成平台的义务或承诺，平台不能保证及时发现违法行为或进行相应处理。
      </span>
    </p>
    <p class="pt">
      <span class="enb">9.5</span>
      <span class="chb">
        您阅读、理解并同意：关于本协议服务，平台不提供任何种类的明示或暗示担保或条件，包括但不限于商业适售性、特定用途适用性等。您对本服务的使用行为一定程度需自行承担相应风险。
      </span>
    </p>
    <p class="pt">
      <span class="enb">9.6</span>
      <span class="chb">
        您阅读、理解并同意，本协议是在保障遵守国家法律法规、维护公序良俗，保护他人合法权益，平台在能力范围内尽最大的努力按照相关法律法规进行判断，但并不保证平台判断完全与司法机关、行政机关的判断一致，如因此产生的后果用户已经理解并同意自行承担。
      </span>
    </p>
    <h4 style="font-weight: bold;">
      <span style="font-family: Calibri;">10</span>
      <span style="font-family: 宋体;">、未成年人使用条款</span>
    </h4>
    <p class="pt">
      <span class="enb">10.1</span>
      <span class="chb">
        若用户是未满18周岁的未成年人，应在监护人监护、指导并获得监护人同意情况下认真阅读本协议后，方可使用本平台服务。
      </span>
    </p>
    <p class="pt">
      <span class="enb">10.2</span>
      <span class="chb">
        平台重视对未成年人个人信息的保护，未成年用户在填写个人信息时，请加强个人保护意识并谨慎对待，并在监护人指导时正确使用本平台服务。
      </span>
    </p>
    <p class="pt">
      <span class="enb">10.3</span>
      <span class="chb">
        未成年用户理解如因你违反法律法规、本协议内容，则你及你的监护人应依照法律规定承担因此而可能引起的全部法律责任。
      </span>
    </p>
    <p class="pt">
      <span class="enb">10.4</span>
      <span class="chb">
        未成年人用户特别提示：
      </span>
    </p>
    <p class="pt">
      <span class="enb">10.4.1</span>
      <span class="chb">
        青少年使用本服务应该在其监护人的监督指导下，在合理范围内正确学习使用网络，避免沉迷虚拟的网络空间，养成良好上网习惯。
      </span>
    </p>
    <p class="pt">
      <span class="enb">10.4.2</span>
      <span class="chb">
        青少年用户必须遵守《全国青少年网络文明公约》：
      </span>
    </p>
    <p class="pt">
      <span class="chb">（1）要善于网上学习，不浏览不良信息；</span>
    </p>
    <p class="pt">
      <span class="chb">（2）要诚实友好交流，不侮辱欺诈他人；</span>
    </p>
    <p class="pt">
      <span class="chb">（3）要增强自护意识，不随意约会网友；</span>
    </p>
    <p class="pt">
      <span class="chb">（4）要维护网络安全，不破坏网络秩序；</span>
    </p>
    <p class="pt">
      <span class="chb">（5）要有益身心健康，不沉溺虚拟时空。</span>
    </p>
    <p class="pt">
      <span class="chb">为更好的保护未成年人隐私权益，平台提醒用户慎重发布包含未成年人素材的内容，一经发布，即视为用户同意本服务展示未成年人的信息、肖像、声音等，且允许平台依据本协议使用、处理该等与未成年人相关的内容。</span>
    </p>
    <h4 style="font-weight: bold;">
      <span style="font-family: Calibri;">11</span>
      <span style="font-family: 宋体;">、其他</span>
    </h4>
    <p class="pt">
      <span class="enb">11.1</span>
      <span class="chb">
        本协议的成立、生效、履行、解释及争议的解决均应适用中华人民共和国大陆地区法律。倘本协议之任何规定因与中华人民共和国的法律抵触而无效，则这些条款将尽可能接近本协议原条文意旨重新解析，且本协议其它规定仍应具有完整的效力及效果。
      </span>
    </p>
    <p class="pt">
      <span class="enb">11.2</span>
      <span class="chb">
        本协议的签订地为中华人民共和国江苏省苏州市，若您因本协议与公司发生争议的，双方应尽量友好协商解决，协商不成，您同意应将争议提交至本平台注册主体住所地人民法院管辖。
      </span>
    </p>
    <p class="pt">
      <span class="enb">11.3</span>
      <span class="chb">
        为给你提供更好的服务或国家法律法规、政策调整，平台服务将不时更新与变化，我们会适时对本协议进行修订，这些修订构成本协议的一部分。本协议更新后，我们会在更新后的条款生效前通过客户端消息通知的方式提醒你更新的内容，以便你及时了解本协议的最新版本。如你继续使用本平台的服务，表示同意接受修订后的本协议的内容。
      </span>
    </p>
    <p class="pt">
      <span class="en">11.4</span>
      <span class="ch">
        本协议中的标题仅为方便及阅读而设，并不影响本协议中任何规定的含义或解释。
      </span>
    </p>
    <p class="pt">
      <span class="en">11.5</span>
      <span class="ch">
        您和平台均是独立的主体，在任何情况下本协议不构成平台对用户的任何形式的明示或暗示担保或条件，双方之间亦不构成代理、合伙、合营或雇佣关系。
      </span>
    </p>
  </div>
</template>

<script>
const PalauAPI = window.PalauAPI
export default {
  mounted() {
    if (typeof SZJSBridge !== 'undefined') {
      PalauAPI.view.showHeader()
      PalauAPI.view.toggleShareBtn()
    }
  }
}
</script>
<style lang="stylus">
.content
  width 100%
  height: 100%;
  overflow-x hidden
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch
  position relative
  padding 0 30px
.ch
  font-family: '宋体'
  font-size: 10.5pt
.en
  font-family: 'Calibri'
  font-size: 10.5pt
.pt
  font-size: 10.5pt
  line-height: 115%
  margin: 0pt 0pt 10pt
  orphans: 0
  widows: 0
.enb
  font-weight: bold
  font-family: 'Calibri'
  font-size: 10.5pt
.chb
  font-weight: bold
  font-family: '宋体'
  font-size: 10.5pt
h4
  font-size: 14pt;
  line-height: 155%;
  margin: 14pt 0pt 14.5pt;
  orphans: 0;
  page-break-after: avoid;
  page-break-inside: avoid;
  text-align: justify;
  text-indent: 0pt;
  widows: 0;
</style>
